import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawQuizIcon.svg.jsx";

const RawQuizIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default RawQuizIcon;
